import { graphQLClient } from '../../../../api/gqlApi';
import { MESSAGE_FORM_SUBMISSION_MUTATION } from './../graphql/valuation-form.mutations';
import { MessageFormSubmissionInput } from './../model/message-form.model';

export const submitMessageForm = async (input: MessageFormSubmissionInput) => {
  const resp = await graphQLClient.request(MESSAGE_FORM_SUBMISSION_MUTATION, input)
  return resp
}